// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3Dkvl","paramInput":"JobSimulator_paramInput__12DC1","input":"JobSimulator_input__lHxAL"};